import { apiLocal } from './servers/apiInternal';

export interface ReverseCustomer {
  customerId: string;
  customerName: string;
  credentialId?: string;
  credentialName?: string;
  [key: string]: any;
}

const reverseEngineering = {
  listCustomers: async (): Promise<ReverseCustomer[]> => {
    const res = await apiLocal.get('/reverse/customers');
    return res.data?.data || [];
  },
  search: async (payload: { customers: string[]; value: string }) => {
    const res = await apiLocal.post('/reverse/search', payload);
    return res.data;
  },
  searchBoth: async (payload: { customers: string[]; value: string }) => {
    const res = await apiLocal.post('/push/buscar-id', payload);
    return res.data;
  },
};

export default reverseEngineering;

